import {
  getAchievementsOptions,
  getAchievementsQueryKey,
  type GetAchievementsData,
  type GetAchievementResponseDto,
} from '@helios/frontend-api-v2-client';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getFriendlyError } from '../../utils/error';

export const QUERY_KEY_ACHIEVEMENTS = getAchievementsQueryKey;

interface UseAchievementsProps {
  data: GetAchievementResponseDto[];
  error: string | null;
  isLoading: boolean;
  isFetched: boolean;
  errorStatusCode?: number;
}

interface UseAchievementsParams {
  params?: GetAchievementsData['query'];
  refetchInterval?: number;
}

export const useAchievements = ({ params, refetchInterval }: UseAchievementsParams = {}): UseAchievementsProps => {
  const { data, error, isPending, isFetched } = useQuery({
    ...getAchievementsOptions({ query: params }),
    refetchInterval,
  });

  return {
    data: data ?? [],
    error: getFriendlyError(error as AxiosError, 'achievements') || null,
    isLoading: isPending,
    isFetched,
    errorStatusCode: (error as AxiosError)?.response?.status,
  };
};
